export default {
      id: "youtube-usage",
      viewBox: "0 0 35 35",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#youtube",
      toString: function () {
        return this.url;
      }
    }